export const getParameterName = (name) => (code) => `${name}.parameters.${code}`;
